import { GraphQLClient } from 'graphql-request';

export const gqlClient = new GraphQLClient('/_internal/bff');
